import { FormCommonProps } from "src/components/common/forms/types";
import { PartCategoryApi } from "src/api/generated/erp/parts/categories/partCategoryApi";
import { PartCategory } from "src/api/generated/erp/db/types/tables/partCategory";
import { useTranslation } from "react-i18next";
import { AavoForm } from "src/components/common/forms/AavoForm.tsx";
import { FormTextField } from "src/components/common/forms/fields/FormTextField";
import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";
import { DeepPartial, useForm } from "react-hook-form";
import { requireRule } from "src/components/common/forms/validation";

export interface PartCategoryFormProps extends FormCommonProps<number> {
	partCategoryId?: number;
	parentId?: number | null;
}

export const PartCategoryForm = ({ partCategoryId, parentId, ...other }: PartCategoryFormProps) => {
	const fetchDefaultValues = async () => {
		return partCategoryId !== undefined
			? await PartCategoryApi.getSingle({ partCategoryId })
			: {
					parentId: parentId,
			  };
	};
	return (
		<AsyncFetchRender
			fetch={fetchDefaultValues}
			content={(defaultValues) => {
				return <PartCategoryFormContent defaultValues={defaultValues} {...other} />;
			}}
		/>
	);
};

export interface PartCategoryFormContentProps extends FormCommonProps<number> {
	defaultValues: DeepPartial<PartCategory>;
}

export const PartCategoryFormContent = ({
	defaultValues,
	onFormEdited,
	...other
}: PartCategoryFormContentProps) => {
	const { t } = useTranslation();
	const {
		control,
		handleSubmit,
		formState: { isDirty },
		watch,
	} = useForm<PartCategory>({
		mode: "all",
		defaultValues: defaultValues,
	});

	if (onFormEdited) watch(onFormEdited);

	return (
		<AavoForm
			handleSubmit={handleSubmit}
			isDirty={isDirty}
			submit={submitForm}
			columns={1}
			{...other}
		>
			<FormTextField
				control={control}
				name={"categoryName"}
				label={t("part_category")}
				rules={requireRule()}
				autoFocus
			/>
		</AavoForm>
	);
};

const submitForm = async (partCategory: PartCategory): Promise<number> => {
	const result = await PartCategoryApi.save({ partCategory });
	return result.partCategoryId;
};
